import {WellLabel} from 'contents/PlateTypeEditor/PlateTypeEditorEnum';

export const PicklistPlateType = {
  [WellLabel.WELL_1]: 'oneWell',
  [WellLabel.WELL_8]: 'eightWell',
  [WellLabel.WELL_12]: 'twelveWell',
  [WellLabel.WELL_96]: 'ninetySix',
  [WellLabel.WELL_384]: 'threeEightyFour',
  [WellLabel.WELL_24]: 'twentyFour',
  [WellLabel.WELL_48]: 'fortyEight',
};

export const InitialPicklistHoverState = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
};
